import { createBrowserRouter, createHashRouter, RouterProvider } from "react-router-dom";
import ProtectedRoutes from "./ProtectedRoutes";
import Login from "../pages/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import Header from "../layout/Header";
import Users from "../pages/Masters/Users";
import Expenses from "../pages/Masters/Expenses";
import Page404 from "../layout/Page404";
import Unauthorized from "../pages/Othes/unauthorized";
import Category from "../pages/Masters/Category";
import Supplier from "../pages/Masters/Supplier";
import Product from "../pages/Masters/Product";
import Purchase from "../pages/Purchase/Purchase";
import PurchaseReturn from "../pages/PurchaseReturn/PurchaseReturn";
import PurchaseReport from "../pages/Reports/PurchaseReport";
import Sales from "../pages/Sales/Sales";
import ViewSale from "../pages/Sales/ViewSales";
import SaleReport from "../pages/Reports/SalesReport";
import StockReport from "../pages/Reports/StockReport";
import SaleInvoice from "../pages/Invoices/SaleInvoice";
import PurchaseInvoice from "../pages/Invoices/PurchaseInvoice";
import ProductList from "../pages/Masters/ProductList";
import OfferTime from "../pages/Masters/OfferTime";
import Customers from "../pages/Masters/Customers";
import Upis from "../pages/Masters/Upis";
import ViewPurchase from "../pages/Purchase/ViewPurchase";
import Store from "../pages/Masters/Store";
import ExpensesEntry from "../pages/Othes/ExpensesEntry";
import PurchaseReturnReport from "../pages/Reports/PurchaseReturnReport";
import ViewPurchaseRetrun from "../pages/PurchaseReturn/ViewPurchaseReturn";
import ExpensesReport from "../pages/Reports/ExpensesReport";
import PurchaseReturnInvoice from "../pages/Invoices/PurchaseReturnInvoice";
import SalesReturn from "../pages/Sales Return/SalesReturn";
import ViewSalesRetuirn from "../pages/Sales Return/ViewSalesRetuirn";
import SalesReportReturn from "../pages/Reports/SalesReportReturn";
import SaleReturnInvoice from "../pages/Invoices/SaleReturnInvoice";
import EmployeeSales from "../pages/Employee Sale/EmployeeSales";
import ViewEmployeeSales from "../pages/Employee Sale/ViewEmployeeSales";
import EmployeeSalesReport from "../pages/Reports/EmployeeSalesReport";
import Orders from "../pages/Order/Orders";
import ViewOrder from "../pages/Order/ViewOrder";
import OrderReport from "../pages/Reports/OrderReport";
import OrderInvoice from "../pages/Invoices/OrderInvoice";
import Settings from "../pages/Othes/Settings";
import TodaysPrint from "../pages/Invoices/TodaysPrint";
import UsersList from "../pages/Masters/UsersList";
import StockPrint from "../pages/Invoices/StockPrint";
import StockValuationReport from "../pages/Reports/StockValuationReport";
import StockTransfer from "../pages/Stock Transfer/StockTransfer";
import StockTransferReport from "../pages/Reports/StockTransferReport";
import ViewStockTransfer from "../pages/Stock Transfer/ViewStockTransfer";
import StockTransferInvoice from "../pages/Invoices/StockTransferInvoice";
import ImportProducts from "../pages/Masters/ImportProducts";

const routes = [
    // Root and Main Pages
    { path: "/", element: <Dashboard />, routeName: 'Dashboard' },

    // Employee and Users
    { path: "/Users/:user_id?", element: <Users />, routeName: 'Users' },
    { path: "/UsersList", element: <UsersList />, routeName: 'UsersList' },

    // Expenses and Reports
    { path: "/Expenses", element: <Expenses />, routeName: 'Expenses' },
    { path: "/EmployeeSalesReport/:limit?/:order?", element: <EmployeeSalesReport />, routeName: 'EmployeeSalesReport' },
    { path: "/ExpensesReports/:limit?/:order?", element: <ExpensesReport />, routeName: 'ExpensesReport' },
    { path: "/PurchaseReports/:limit?/:order?", element: <PurchaseReport />, routeName: 'PurchaseReport' },
    { path: "/StockTransferReports/:limit?/:order?", element: <StockTransferReport />, routeName: 'StockTransferReport' },
    { path: "/PurchaseReturnReports/:limit?/:order?", element: <PurchaseReturnReport />, routeName: 'PurchaseReturnReport' },
    { path: "/SaleReports/:limit?/:order?", element: <SaleReport />, routeName: 'SalesReport' },
    { path: "/OrderReport/:limit?/:order?", element: <OrderReport />, routeName: 'OrdersReport' },
    { path: "/SaleReturnReports/:limit?/:order?", element: <SalesReportReturn />, routeName: 'SalesReturnReport' },
    { path: "/StockReport/:limit?/:order?", element: <StockReport />, routeName: 'StockReport' },
    { path: "/StockValuation/:limit?/:order?", element: <StockValuationReport />, routeName: 'StockValuation' },

    // Sales and Purchase
    { path: "/Purchase/:purchase_id?/:para_store_id?", element: <Purchase />, routeName: 'Purchase' },
    { path: "/StockTransfer/:purchase_id?/:inv_transfer_id?", element: <StockTransfer />, routeName: 'StockTransfer' },
    { path: "/PurchaseReturn/:purchase_return_id?", element: <PurchaseReturn />, routeName: 'PurchaseReturn' },
    { path: "/ViewPurchase/:purchase_id?", element: <ViewPurchase />, routeName: 'ViewPurchase' },
    { path: "/ViewStockTransfer/:inv_transfer_id/:purchase_id?", element: <ViewStockTransfer />, routeName: 'ViewStockTransfer' },
    { path: "/ViewPurchaseReturn/:purchase_return_id?", element: <ViewPurchaseRetrun />, routeName: 'ViewPurchaseReturn' },
    { path: "/Sales/:sale_id?/:para_store_id?", element: <Sales />, routeName: 'Sales' },
    { path: "/OrdersEntry/:order_id?/:para_store_id?", element: <Orders />, routeName: 'OrdersEntry' },
    { path: "/EmployeeSales/:employee_sale_id?/:para_store_id?", element: <EmployeeSales />, routeName: 'EmployeeSales' },
    { path: "/SalesReturn/:sale_return_id?/:para_store_id?", element: <SalesReturn />, routeName: 'SalesReturn' },
    { path: "/ViewSale/:sale_id?", element: <ViewSale />, routeName: 'ViewSale' },
    { path: "/ViewOrder/:order_id?", element: <ViewOrder />, routeName: 'ViewOrder' },
    { path: "/ViewSalesRetuirn/:sale_return_id?", element: <ViewSalesRetuirn />, routeName: 'ViewSalesReturn' },
    { path: "/ViewEmployeeSales/:employee_sale_id?", element: <ViewEmployeeSales />, routeName: 'ViewEmployeeSales' },
    { path: "/PrintSale/:sale_id?", element: <SaleInvoice />, routeName: 'PrintSale' },
    { path: "/PrintPurchase/:purchase_id?/:stock_status?", element: <PurchaseInvoice />, routeName: 'PrintPurchase' },
    { path: "/StockTransferInvoice/:inv_transfer_id?/:stock_status?", element: <StockTransferInvoice />, routeName: 'StockTransferInvoice' },
    { path: "/PrintOrder/:order_id?/:stock_status?", element: <OrderInvoice />, routeName: 'PrintOrder' },
    { path: "/PrintPurchaseReturn/:purchase_return_id?/:stock_status?", element: <PurchaseReturnInvoice />, routeName: 'PrintPurchaseReturn' },
    { path: "/SaleReturnInvoice/:sale_return_id?/:stock_status?", element: <SaleReturnInvoice />, routeName: 'SaleReturnInvoice' },

    // Masters
    { path: "/Category", element: <Category />, routeName: 'Category' },
    { path: "/Store", element: <Store />, routeName: 'Store' },
    { path: "/Customers", element: <Customers />, routeName: 'Customers' },
    { path: "/Upis", element: <Upis />, routeName: 'Upis' },
    { path: "/Supplier", element: <Supplier />, routeName: 'Suppliers' },
    { path: "/Product/:product_id?", element: <Product />, routeName: 'Products' },
    { path: "/ImportProducts", element: <ImportProducts />, routeName: 'ImportProducts' },
    { path: "/ProductList", element: <ProductList />, routeName: 'ProductList' },
    { path: "/OfferTime/:id?", element: <OfferTime />, routeName: 'OfferTime' },

    { path: "/ExpensesEntry", element: <ExpensesEntry />, routeName: 'ExpensesEntry' },
    { path: "/Settings", element: <Settings />, routeName: 'Settings' },
];

export default routes;
